const MultiTicketsSkeleton = () => (
  <div className="h-full px-4 pt-14 animate-pulse">
    <div className="px-4 pb-24 h-full">
      <div className="p-10 flex justify-center">
        <div className="w-56 h-56 bg-gray-200 rounded-2xl" />
      </div>
      <div className="p-10 flex justify-center">
        <div className="w-56 h-56 bg-gray-200 rounded-2xl" />
      </div>
      <div className="p-10 flex justify-center">
        <div className="w-56 h-56 bg-gray-200 rounded-2xl" />
      </div>
      <div className="p-10 flex justify-center">
        <div className="w-56 h-56 bg-gray-200 rounded-2xl" />
      </div>
    </div>
  </div>
);

export default MultiTicketsSkeleton;
